import { DEVELOPMENT_TYPE } from "Constants";

export default function () {
  if (DEVELOPMENT_TYPE === "koachify") {
    return [
      /*{iconName:'',bsClass:'Logo',description:''},*/
      {
        iconName: "General",
        bsClass: "general",
        description: "General information about your app and platform.",
      },
      {
        iconName: "Features",
        bsClass: "features",
        description: "Add a new feature to your platform app.",
      },
      {
        iconName: "Branding",
        bsClass: "branding",
        description:
          "Customize your app look and feel that matches with your brand.",
      },
      {
        iconName: "Contents",
        bsClass: "content",
        description: "Manage, add or remove your app contents.",
      },
      {
        iconName: "Website",
        bsClass: "website",
        description:
          "See preview of available website templates, and build your website on fly.",
      },
      {
        iconName: "Plans",
        bsClass: "tickets",
        description: "Manage plans for the event.",
      },
      {
        iconName: "Users",
        bsClass: "users",
        description: "Manage and import users in your platform.",
      },
      {
        iconName: "Polls & Live QA",
        bsClass: "polls",
        description: "Manage Live QA and Polls",
      },
      {
        iconName: "Outreach",
        bsClass: "outreach",
        description: "Broadcast message to users",
      },
      {
        iconName: "Analytics",
        bsClass: "analytics",
        description: "View App analytics!",
      }, // stats
      {
        iconName: "Courses",
        bsClass: "courses",
        description: "Manage courses for the platform.",
      },
      // {iconName:'Publish',bsClass:'publish',description:'A paid plan is required to publish this app.'},
    ];
  } else {
    return [
      /*{iconName:'',bsClass:'Logo',description:''},*/
      {
        iconName: "General",
        bsClass: "general",
        description: "General information about your app and event.",
      },
      {
        iconName: "Features",
        bsClass: "features",
        description: "Add a new feature to your event app.",
      },
      {
        iconName: "Branding",
        bsClass: "branding",
        description:
          "Customize your app look and feel that matches with your brand.",
      },
      {
        iconName: "Contents",
        bsClass: "content",
        description: "Manage, add or remove your app contents.",
      },
      {
        iconName: "Website",
        bsClass: "website",
        description:
          "See preview of available website templates, and build your website on fly.",
      },
      {
        iconName: "Tickets",
        bsClass: "tickets",
        description: "Manage tickets for the event.",
      },
      {
        iconName: "Users",
        bsClass: "users",
        description: "Manage and import users in your event app.",
      },
      {
        iconName: "Polls & Live QA",
        bsClass: "polls",
        description: "Manage Live QA and Polls",
      },
      {
        iconName: "Outreach",
        bsClass: "outreach",
        description: "Broadcast message to users",
      },
      {
        iconName: "Analytics",
        bsClass: "analytics",
        description: "View App analytics!",
      },
      {
        iconName: "Gamification",
        bsClass: "gamification",
        description: "Manage gamification!",
      },
      {
        iconName: "Help & Support",
        bsClass: "support",
        description: "Support to attendess.",
      },
      // {iconName:'Publish',bsClass:'publish',description:'A paid plan is required to publish this app.'},
    ];
  }
}
